export default "__VITE_ASSET__BiSj9Lb1__"